(() => {
    const language = document.documentElement.lang;
    const domainParts = window.location.hostname.split('.');
    const domain = `.${domainParts.filter((part) => part !== 'www' && part !== language).join('.')}`;
    const callbacks = {};
    const cookieValues = `${(document.cookie || '')}`.split('; ').reduce((map, entry) => {
        const [currentKey, currentValue] = (entry || '').split('=');
        map[currentKey] = currentValue;
        return map;
    }, {});

    window.Cookies = {
        remove: (key) => {
            if (!window.Cookies.get(key)) {
                return;
            }
            document.cookie = `${key}=;path=/${!domain.startsWith('localhost') ? `;domain=${domain}` : ''};max-age=-99999999`;
        },
        set: (key, value, expires = 31536000) => {
            window.Cookies.remove(key);
            document.cookie = `${key}=${value};path=/${!domain.startsWith('localhost') ? `;domain=${domain}` : ''};max-age=${expires}`;
        },
        get: (key) => `${(document.cookie || '')}`.split('; ').reduce((result, entry) => {
            const [currentKey, currentValue] = (entry || '').split('=');
            return currentKey === key ? currentValue : result;
        }, null),
        onChange: (key, callback) => {
            const currentValue = window.Cookies.get(key);
            cookieValues[key] = currentValue;
            callback(currentValue);

            if (!callbacks[key]) {
                window.setInterval(() => {
                    const currentValue = window.Cookies.get(key);

                    if (cookieValues[key] === currentValue) {
                        return;
                    }

                    cookieValues[key] = currentValue;
                    callbacks[key].forEach(callback => callback(currentValue));
                }, 100);
                callbacks[key] = [callback];
            } else {
                callbacks[key].push(callback);
            }
        }
    };
})();
